/**
 * Builds the WebSocket URL for the gateway (e.g. ws://host:port/ws or wss://host/ws).
 */
import { GATEWAY_WEBSOCKET_CHANNEL_PATH } from '@/core/const/gatewayRoutes.const'

import { buildGatewayHost } from './buildGatewayHost'

export const buildWsUrl = (path: string, port?: string, isSecured?: boolean) => {
  const protocol = isSecured ? 'wss' : 'ws'

  return `${protocol}://${buildGatewayHost(path, port)}/${GATEWAY_WEBSOCKET_CHANNEL_PATH}`
}
